<template>
  <div
    class="fixed h-screen w-screen bg-black top-0 z-50 left-0 bg-opacity-50 flex items-center justify-center backdrop-blur-sm"
    v-if="value"
  >
    <div class="relative bg-graybase overflow-hidden">

      
      <div class="w-full h-full py-4 lg:py-16 px-16 lg:px-24  rounded border-2 border-primary max-w-2xl">
        <LucideX @click="$emit('close')" class="absolute top-0 right-0 m-6 lg:m-10 cursor-pointer"/>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],
};
</script>